import supports from '../lib/supports.js';
import {gsap} from 'gsap';
import {reducedDuration} from '../lib/reduced-motion.js';

const setupObserver = (element) => {
  const observer = new IntersectionObserver(([e]) => {
    if (e.isIntersecting) {
      // Nav is in view on screen — hide fixed nav, show header
      gsap.to('.section-buy-now.is-fixed', {
        duration: reducedDuration(0.3),
        y: '-100%',
      });
      gsap.to('.site-header', {
        duration: reducedDuration(0.3),
        y: 0,
      });
    } else if (e.intersectionRatio < 1) {
      // Nav is out of view
      if (e.boundingClientRect.top < e.intersectionRect.top) {
        // Scrolled past top — show fixed nav, hide header
        gsap.to('.section-buy-now.is-fixed', {
          duration: reducedDuration(0.3),
          y: 0,
        });
        gsap.to('.site-header', {
          duration: reducedDuration(0.3),
          y: '-100%',
        });
      } else {
        // Scrolled from bottom — hide fixed nav, show header
        gsap.to('.section-buy-now.is-fixed', {
          duration: reducedDuration(0.3),
          y: '-100%',
        });
        gsap.to('.site-header', {
          duration: reducedDuration(0.3),
          y: 0,
        });
      }
    }
  });

  observer.observe(element);
};

const cloneNav = (element) => {
  const subNav = element.querySelector('[data-element="section-buy-now"]');
  const subNavClone = subNav.cloneNode(true);

  const fixedNav = document.createElement('div');
  fixedNav.classList.add('section-buy-now', 'bg-midnight', 'is-fixed');

  fixedNav.append(subNavClone);
  document.body.append(fixedNav);
};

const sectionBuyNow = {
  init() {
    const element = document.querySelector('[data-module="sticky-buy-now"]');

    if (element && supports.intersectionObserver) {
      setupObserver(element);
      cloneNav(element);
    }
  },
};

export default sectionBuyNow;
